<template>
  <el-tooltip
    :disabled="!item.onlyRegistered"
    class="item"
    effect="dark"
    placement="top-start"
  >
    <template slot="content">
      <span class="" v-if="item.onlySubscribed">
        For {{ item.memberships[0].name }} Only
      </span>
      <span class="" v-if="item.onlyRegistered && !item.onlySubscribed">
        For Registered Users Only
      </span>
    </template>
    <div class="md:mt-0 relative lg:mt-0 mt-6 shadow-xl bg-white rounded-b-lg">
      <!-- <div
      v-if="
        Object.keys(user).length !== 0 &&
        Object.hasOwn(user, 'currentMembership') &&
        user.currentMembership.length !== 0 &&
        user.currentMembership != null &&
        Object.hasOwn(item, 'memberships') &&
        item.memberships != null &&
        Object.keys(item.memberships).length !== 0
      "
    >
      <span class="absolute top-3 left-1 z-index-999">
        <img
          class="rounded-full w-6 h-6"
          :src="$imageURL + '/' + item.memberships[0].image"
          :style="{}"
        />
    
      </span>
    </div> -->
      <div>
        <span
          class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
          v-if="item.onlySubscribed"
        >
          For Subscribers Only
        </span>
        <span
          class="absolute top-3 left-3 z-index-999 flex gap-1 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
          v-if="item.onlyRegistered && !item.onlySubscribed"
          ><feather-icon icon="UnlockIcon" svgClasses="w-4" />
          Access Caregiver Saathi
        </span>
      </div>
      <!-- <div
      v-if="
        Object.keys(user).length == 0 &&
        Object.hasOwn(item, 'memberships') &&
        item.memberships != null &&
        Object.keys(item.memberships).length !== 0
      "
      class="relative"
    >
      <span class="absolute top-3 left-1 z-index-999">
        <img
          class="rounded-full w-6 h-6"
          :src="$imageURL + '/' + item.memberships[0].image"
          :style="{}"
        />
        {{ item.memberships[0].name }}
      </span>
    </div> -->
      <!-- <span class="blog-tooltiptext-ui" v-if="item.onlySubscribed">
        For {{ item.memberships[0].name }} Only
      </span>
      <span
        class="blog-tooltiptext-ui"
        v-if="item.onlyRegistered && !item.onlySubscribed"
      >
        For Registered Users Only
      </span> -->
      <div class="flex justify-between relative">
        <img
          :src="hasError ? defaultImage : image"
          alt="Event image"
          class="rounded-t-lg h-52 w-full object-contain cursor-pointer"
          @error="hasError = true"
        />
        <div class="absolute right-5 top-2" v-if="type === 'Upcoming'">
          <!-- v-b-modal.modal-1 -->
          <img
            @click="setLink(url)"
            src="../../../../assets/images/share.png"
            alt="ShareIcon"
            class="h-5 w-5 cursor-pointer"
          />
        </div>
      </div>
      <a class="cursort-pointer" @click="handleOpenLink">
        <div class="p-4">
          <div class="">
            <div>
              <p
                class="text-black font-bold cursor-pointer fsize20-14px ellipsis-1 lh-28"
              >
                {{ item.title }}
              </p>
              <p class="text-sm">
                Date:
                {{
                  item.hasOwnProperty("date")
                    ? new Date(item.date).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      })
                    : new Date(item.eventDate).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      })
                }}
              </p>
              <p class="text-sm">
                Time:
                {{ item.hasOwnProperty("time") ? item.time : item.eventTime }}
              </p>
            </div>
          </div>
          <p class="text-sm ellipsis-3">
            {{ item.linktext }}
          </p>
        </div>
        <!-- <p class="text-sm">
        {{ item.webinar }}<span class="text-primary pl-1 underline">here</span>
      </p> -->
      </a>

      <!-- <img
      v-b-modal.modal-1
      @click="
        dialogVisible = true;
        setLink(item.link);
      "
      src="./../../../../assets/images/share.png"
      alt="ShareIcon"
      class="h-6 w-6 cursor-pointer"
    /> -->
    </div>
  </el-tooltip>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      categoryId: "",
      hasError: false,
      copy: "",
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      shareImage: require("../../../../assets/images/share.png"),
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.item.bannerImage
        ? `${this.$imageURL}/${this.item.bannerImage}`
        : `${this.$imageURL}/${this.item.defaultImage}`;
    },
    url() {
      if (this.item.link.includes("http")) {
        return this.item.link;
      } else {
        return "https://" + this.item.link;
      }
    },
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
  },
  methods: {
    // handleShare(event) {
    //   // dialogVisible = true;
    //   setLink(item.link);
    //   event.stopPropagation();
    // },
    setLink(link) {
      //    this.copy = link;
      // this.$emit("eventCopy", link);
      let clickedBlogId = "";
      if (Object.keys(this.user).length !== 0) {
        if (this.type.includes("Featured")) {
          this.categorywisepagesforevent.featured.forEach((element) => {
            if (element._id === this.item._id) {
              if (
                element.memberships != null &&
                element.memberships.length !== 0
              ) {
                clickedBlogId = element.memberships[0]._id;
              }
            }
          });
        } else if (this.type.includes("Past")) {
          this.categorywisepagesforevent.past.forEach((element) => {
            // console.log("Past Here");
            if (element._id === this.item._id) {
              if (
                element.memberships != null &&
                element.memberships.length !== 0
              ) {
                clickedBlogId = element.memberships[0]._id;
              }
            }
          });
        } else if (this.type.includes("Upcoming")) {
          this.categorywisepagesforevent.upcoming.forEach((element) => {
            // console.log("Past Here");
            if (element._id === this.item._id) {
              if (
                element.memberships != null &&
                element.memberships.length !== 0
              ) {
                clickedBlogId = element.memberships[0]._id;
              }
            }
          });
        }
      }
      if (this.item.onlyRegistered) {
        if (Object.keys(this.user).length === 0) {
          this.$router.push({ name: "signin" });
          Swal.fire({
            title: "Login",
            text: "To access the content, kindly proceed with registration/login",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showConfirmButton: true,
          });
          return;
          //   .then((result) => {
          //   if (result.isConfirmed) {
          //     this.$router.push({ name: "signin" });
          //   }
          // });
        } else if (this.item.onlySubscribed) {
          if (
            this.user.membership != null &&
            this.user.membership.includes(clickedBlogId)
          ) {
            // console.log("here");
            this.copy = link;
            this.$emit("eventCopy", link);
            this.$bvModal.show("modal-1");
          } else {
            Swal.fire({
              title: "Upgrade Plan",
              text: "Upgrade now for unrestricted access!",
              icon: "info",
              confirmButtonColor: "#830c81",
              confirmButtonText: "Show Plans",
              showConfirmButton: true,
              showCancelButton: true,
            }).then((e) => {
              if (e.isConfirmed) {
                this.$router.push({
                  path: "/product-services",
                  query: { buymembership: true },
                });
              }
            });
          }
        } else {
          // console.log("here 2");
          this.copy = link;
          this.$emit("eventCopy", link);
          this.$bvModal.show("modal-1");
        }
      } else {
        // console.log("here 3");
        this.copy = link;
        this.$emit("eventCopy", link);
        this.$bvModal.show("modal-1");
      }

      // console.log(link);
    },
    async handleOpenLink() {
      let link = "";
      try {
        let clickedBlogId = "";
        if (Object.keys(this.user).length !== 0) {
          if (this.type.includes("Featured")) {
            this.categorywisepagesforevent.featured.forEach((element) => {
              if (element._id === this.item._id) {
                if (
                  element.memberships != null &&
                  element.memberships.length !== 0
                ) {
                  clickedBlogId = element.memberships[0]._id;
                }
              }
            });
          } else if (this.type.includes("Past")) {
            this.categorywisepagesforevent.past.forEach((element) => {
              // console.log("Past Here");
              if (element._id === this.item._id) {
                if (
                  element.memberships != null &&
                  element.memberships.length !== 0
                ) {
                  clickedBlogId = element.memberships[0]._id;
                }
              }
            });
          } else if (this.type.includes("Upcoming")) {
            this.categorywisepagesforevent.upcoming.forEach((element) => {
              // console.log("Past Here");
              if (element._id === this.item._id) {
                if (
                  element.memberships != null &&
                  element.memberships.length !== 0
                ) {
                  clickedBlogId = element.memberships[0]._id;
                }
              }
            });
          }
        }

        if (this.item.onlyRegistered) {
          if (Object.keys(this.user).length === 0) {
            this.$router.push({ name: "signin" });
            Swal.fire({
              title: "Login",
              text: "To access the content, kindly proceed with registration/login",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showConfirmButton: true,
            });
            return;
            // .then((result) => {
            //   if (result.isConfirmed) {
            //     this.$router.push({ name: "signin" });
            //   }
            // });
          } else if (this.item.onlySubscribed) {
            // console.log("here out", this.type.includes("Past"));
            // console.log(this.user.membership, clickedBlogId);
            if (
              this.user.membership != null &&
              this.user.membership.includes(clickedBlogId)
            ) {
              // console.log("here");
              if (this.item.link.includes("http")) {
                link = this.item.link;
              } else {
                link = "https://" + this.item.link;
              }
              window.open(link, "_blank");
            } else {
              Swal.fire({
                title: "Upgrade Plan",
                text: "Upgrade now for unrestricted access!",
                icon: "info",
                confirmButtonColor: "#830c81",
                confirmButtonText: "Show Plans",
                showConfirmButton: true,
                showCancelButton: true,
              }).then((e) => {
                if (e.isConfirmed) {
                  this.$router.push({
                    path: "/product-services",
                    query: { buymembership: true },
                  });
                }
              });
            }
          } else {
            // console.log("here 2");
            if (this.item.link.includes("http")) {
              link = this.item.link;
            } else {
              link = "https://" + this.item.link;
            }
            window.open(link, "_blank");
          }
        } else {
          // console.log("here 3");

          if (this.item.link.includes("http")) {
            link = this.item.link;
          } else {
            link = "https://" + this.item.link;
          }
          window.open(link, "_blank");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    // if (Object.keys(this.user).length !== 0) {
    //   let getUserPayload = {
    //     userId: this.user._id,
    //   };
    //   const getUser = await this.$store.dispatch(
    //     "auth/getUserByUserId",
    //     getUserPayload
    //   );
    // }
  },
};
</script>

<style>
.bottom-63p {
  bottom: 63%;
}
</style>
